import React, { useEffect } from 'react';

import { css } from '@betterment/samba-styled-system/css';

export interface CapitalizeWebviewContentProps {
  webviewUrl: string;
  internalRolloverRedirectPath: string;
}

export const CapitalizeWebviewContent: React.FC<CapitalizeWebviewContentProps> = ({
  webviewUrl,
  internalRolloverRedirectPath,
}) => {
  useEffect(() => {
    const handler = (event: MessageEvent<EventData>) => handleWindowEvent(event, internalRolloverRedirectPath);
    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, [internalRolloverRedirectPath]);

  return (
    <iframe
      className={css({
        width: '100%',
        height: '500px',
        border: 'none',
      })}
      src={webviewUrl}
      title="Capitalize rollover webview"
    />
  );
};

type TransactionId = string;
type ErrorMessage = string;
type EventData =
  | { onCapitalize401kStepComplete: TransactionId }
  | { onCapitalizeExit: true }
  | { onCapitalizeRolloverCanceled: TransactionId }
  | { onCapitalizeRolloverCreated: TransactionId }
  | { onCapitalizeRolloverSubmitted: true }
  | { onCapitalizeRolloverSubmittedV2: TransactionId }
  | { onCreateRothDestinationNeeded: TransactionId }
  | { onCreateRothIra: TransactionId }
  | { onCreateTradDestinationNeeded: TransactionId }
  | { onCreateTradIra: TransactionId }
  | { onError: ErrorMessage }
  | { onPartnerInternalRolloverRedirect: true };

function handleWindowEvent(event: MessageEvent<EventData>, internalRolloverRedirectPath: string) {
  const { data } = event;

  if ('onCreateRothDestinationNeeded' in data) {
    window.console.log('onCreateRothDestinationNeeded', data);
  }

  if ('onCreateTradDestinationNeeded' in data) {
    window.console.log('onCreateTradDestinationNeeded', data);
  }

  if ('onCapitalizeRolloverCreated' in data) {
    window.console.log('onCapitalizeRolloverCreated', data);
  }

  if ('onCapitalizeRolloverSubmittedV2' in data) {
    window.console.log('onCapitalizeRolloverSubmittedV2', data);
  }

  if ('onPartnerInternalRolloverRedirect' in data) {
    window.location.href = internalRolloverRedirectPath;
  }

  if ('onError' in data) {
    window.console.error('Capitalize webview error', data.onError);
  }
}

export default CapitalizeWebviewContent;
